import { render, staticRenderFns } from "./vesselVoyReview.vue?vue&type=template&id=6895bc7c&"
import script from "./vesselVoyReview.vue?vue&type=script&lang=js&"
export * from "./vesselVoyReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports